import React, { useContext, useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  Dimensions,
  Animated,
  Easing,
  View,
} from "react-native";
import { withRouter } from "react-router-dom";
import { ActivityContext } from "../Containers/Activities";
import { moduleid } from "../Utils/static-strings";

const deviceWidth = Dimensions.get("screen").width;
const deviceHeight = Dimensions.get("window").height;

const Index = (props) => {
  const resultContext = useContext(ActivityContext);
  const animated = useRef(new Animated.Value(0)).current;

  const animate = () => {
    Animated.parallel([
      Animated.timing(animated, {
        toValue:
          deviceWidth < 500
            ? props.currentModule !== null && props.currentModule === 0
              ? -deviceHeight / 2 + 60
              : props.currentModule === 1
              ? -deviceHeight / 2 - 102 + 60
              : -deviceHeight / 2 - 204 + 20
            : -deviceHeight / 2 + 5,
        duration: 600,
        easing: Easing.in(Easing.ease),
        useNativeDriver: false,
      }),
    ]).start(() => {
      props.history.push(`/activityType/${props.module.moduleid}`);
    });
  };

  const scaling = animated.interpolate({
    inputRange: [
      deviceWidth < 500
        ? props.currentModule !== null && props.currentModule === 0
          ? -deviceHeight / 2 + 60
          : props.currentModule === 1
          ? -deviceHeight / 2 - 102 + 60
          : -deviceHeight / 2 - 204 + 20
        : -deviceHeight / 2 + 5,
      0,
    ],
    outputRange: [0, 1],
  });

  const startAnimation = (currentIndex) => {
    props.setCurrentModule(currentIndex);
    props.setDisplayContainer(false);
    animate();
  };

  const selectStyle = (tab, module, disabled) => {
    const stl = disabled
      ? styles[`oval${module}Disabled`]
      : styles[`oval${module}`];
    return stl;
  };

  const setModuleOpacity = (currentTab, index, disabled) => {
    if (currentTab === 1) {
      switch (index) {
        case moduleid.experience():
        case moduleid.knowledge():
        case moduleid.esg():
          return disabled ? 0.15 : 0.2;

        default:
          return 1;
      }
    } else if (currentTab === 2) {
      switch (index) {
        case moduleid.risk():
        case moduleid.loss():
        case moduleid.future():
        case moduleid.esg():
          return disabled ? 0.15 : 0.2;

        default:
          return 1;
      }
    } else if (currentTab === 3) {
      switch (index) {
        case moduleid.risk():
        case moduleid.loss():
        case moduleid.future():
        case moduleid.knowledge():
        case moduleid.experience():
          return disabled ? 0.15 : 0.2;

        default:
          return 1;
      }
    }
  };

  const checkDisability = (index, disabled, currentTab) => {
    if (currentTab === 1) {
      switch (index) {
        case moduleid.risk():
        case moduleid.loss():
        case moduleid.future():
          return disabled;

        default:
          return true;
      }
    } else if (currentTab === 2) {
      switch (index) {
        case moduleid.experience():
        case moduleid.knowledge():
          return disabled;

        default:
          return true;
      }
    } else if (currentTab === 3) {
      switch (index) {
        case moduleid.esg():
          return disabled;

        default:
          return true;
      }
    }
  };

  const [scrollViewPos, setScrollViewPos] = useState(
    new Animated.ValueXY(0, 0)
  );

  useEffect(() => {
    if (props.currentSelectedTab === 2) {
      deviceWidth < 500
        ? Animated.spring(scrollViewPos, {
            toValue: { x: 0, y: scrollViewPos.x._value - 306 },
          }).start()
        : Animated.spring(scrollViewPos, {
            toValue: { x: deviceWidth > 1300 ? -382 : -316, y: 0 },
          }).start();
    } else if (props.currentSelectedTab === 1) {
      Animated.spring(scrollViewPos, {
        toValue: { x: 0, y: 0 },
      }).start();
    } else if (props.currentSelectedTab === 3) {
      const temp = props.understandingUI.length === 0 ? -378 : -634;
      deviceWidth < 500
        ? Animated.spring(scrollViewPos, {
            toValue: { x: 0, y: scrollViewPos.x._value - 306 },
          }).start()
        : Animated.spring(scrollViewPos, {
            toValue: { x: deviceWidth > 1300 ? temp : -522, y: 0 },
          }).start();
    }
  }, [props.currentSelectedTab]);

  const Text1 = (props) => {
    return (
      <>
        {props.disabled && props.disabledfuctio(props.index)}

        <TouchableOpacity
          onPress={props.onPress}
          disabled={checkDisability(
            props.moduleid,
            props.disabled,
            props.currentSelectedTab
          )}
          style={{
            opacity:
              props.currentModule !== null
                ? props.currentModule === props.index
                  ? 1
                  : 0
                : 1,
            marginLeft: props.currentSelectedTab === 1 ? 6.3 : 0.5,
            paddingLeft: props.currentSelectedTab === 1 ? null : 3,
          }}
        >
          <Animated.View
            style={[
              scrollViewPos.getLayout(),
              selectStyle(
                props.currentSelectedTab,
                props.moduleid,
                props.disabled
              ),
              {
                opacity: setModuleOpacity(
                  props.currentSelectedTab,
                  props.moduleid,
                  props.disabled
                ),
              },
              { transform: [{ translateY: animated }, { scale: scaling }] },
            ]}
          >
            {props.disabled ? (
              resultContext.riskCalculation !== undefined &&
              resultContext.riskCalculation.calcresults
                .filter((value) => value.moduleid == props.moduleid)
                .map((item) => {
                  return (
                    <>
                      <Text style={[styles.valueTextLarge, { opacity: 1 }]}>
                        {item.measure}
                      </Text>
                      <Text style={[styles.valueTextSmall, { opacity: 1 }]}>
                        {item.chartvalues &&
                          item.chartvalues.length > 0 &&
                          item.chartvalues[0].label}
                      </Text>
                    </>
                  );
                })
            ) : (
              <Text
                style={[
                  styles.value,
                  {
                    color: `var(--module-overlay-text-color-${props.moduleid.toLowerCase()})`,
                  },
                  { opacity: props.currentModule !== null ? 0 : 1 },
                ]}
              >
                {props.title}
              </Text>
            )}
          </Animated.View>
        </TouchableOpacity>
      </>
    );
  };

  return (
    <Text1
      disabled={
        ((resultContext.result &&
          resultContext.result.modules.filter(
            (module) => module.moduleid === props.module.moduleid
          )[0].completedat !== null) ||
          (props.details !== "" &&
            props.details.modules.some(
              (item) => item.moduleid === props.module.moduleid
            ))) &&
        resultContext.riskCalculation !== undefined &&
        resultContext.riskCalculation.modules.some(
          (item) => item.moduleid === props.module.moduleid
        )
      }
      displayContainer={props.displayContainer}
      index={props.index}
      setDisplayContainer={props.setDisplayContainer}
      onPress={() => startAnimation(props.index)}
      currentModule={props.currentModule}
      title={props.module.name}
      disabledfuctio={props.disabledfuctio}
      moduleid={props.module.moduleid}
      {...props}
    />
  );
};

export default withRouter(Index);

const styles = StyleSheet.create({
  ovalATR: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-atr)",
    backgroundColor: "var(--module-color-atr)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalLA: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-la)",
    backgroundColor: "var(--module-color-la)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalPB: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-pb)",
    backgroundColor: "var(--module-color-pb)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalEXP: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-exp)",
    backgroundColor: "var(--module-color-exp)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalOBJ: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-obj)",
    backgroundColor: "var(--module-color-obj)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalESG: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-esg)",
    backgroundColor: "var(--module-color-esg)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalATRDisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-atr)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalLADisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-la)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalPBDisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-pb)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalEXPDisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-exp)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalOBJDisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-obj)",
    alignItems: "center",
    justifyContent: "center",
  },
  ovalESGDisabled: {
    width: deviceWidth > 1300 ? 124 : 102,
    height: deviceWidth > 1300 ? 124 : 102,
    borderWidth: 3,
    borderRadius: 88,
    borderStyle: "solid",
    borderColor: "var(--module-color-esg)",
    alignItems: "center",
    justifyContent: "center",
  },
  value: {
    width: 105,
    height: 27,
    fontFamily: "var(--font-family-default)",
    fontSize: 20,
    textAlign: "center",
    color: "#ffffff",
    lineHeight: 26.5,
  },
  valueTextLarge: {
    width: 105,
    height: 27,
    fontFamily: "var(--font-family-default)",
    fontSize: 18,
    textAlign: "center",
    color: "var(--text-color-default)",
  },
  valueTextSmall: {
    width: 90,
    height: 13,
    fontSize: 9,
    fontWeight: "var(--font-weight-semi-bold)",
    textAlign: "center",
    color: "var(--text-color-default)",
    textTransform: "uppercase",
    alignSelf: "center",
  },
});
